<template>
  <div class="website-page">
    <Tabs value="global" @on-click="showName">
      <TabPane label="全局设置" name="global">
        <Form
          ref="global"
          :rules="globalRule"
          :label-width="150"
          :model="globalData"
          style="width: 550px"
        >
          <FormItem prop="default_pass" label="学员默认密码设置">
            <Input
              placeholder="请输入"
              v-model="globalData.default_pass"
              clearable
            />
          </FormItem>
          <FormItem prop="teacher_default_pass" label="讲师默认密码设置">
            <Input
              placeholder="请输入"
              v-model="globalData.teacher_default_pass"
              clearable
            />
          </FormItem>
          <FormItem label="是否支持app缓存" prop="app_video_cache">
            <RadioGroup v-model="globalData.app_video_cache">
              <Radio label="1">支持</Radio>
              <Radio label="2">不支持</Radio>
            </RadioGroup>
          </FormItem>
          <!-- <FormItem label="会员模块设置" prop="switch_vip_module">
            <RadioGroup v-model="globalData.switch_vip_module">
              <Radio :label="1">开启</Radio>
              <Radio :label="0">关闭</Radio>
            </RadioGroup>
          </FormItem> -->
          <FormItem label="学习卡模块设置" prop="switch_study_module">
            <RadioGroup v-model="globalData.switch_study_module">
              <Radio :label="1">开启</Radio>
              <Radio :label="0">关闭</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="题库模块设置" prop="switch_question_module">
            <RadioGroup v-model="globalData.switch_question_module">
              <Radio :label="1">开启</Radio>
              <Radio :label="0">关闭</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="班级模块设置" prop="class_module">
            <RadioGroup v-model="globalData.class_module">
              <Radio :label="1">开启</Radio>
              <Radio :label="0">关闭</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="作业模块设置" prop="homework_module.is_open">
            <RadioGroup v-model="globalData.homework_module.is_open">
              <Radio label="1">开启</Radio>
              <Radio label="0">关闭</Radio>
            </RadioGroup>
          </FormItem>
          <div v-if="globalData.homework_module.is_open == 1">
            <FormItem
              label="是否布置作业"
              prop="homework_module.is_hw.is_dispatch"
            >
              <RadioGroup
                v-model="globalData.homework_module.is_hw.is_dispatch"
              >
                <Radio label="1">是</Radio>
                <Radio label="0">否</Radio>
              </RadioGroup>
              <FormItem
                label="发布作业"
                prop="dispatch_homework"
                class="form-item-sub"
                v-if="globalData.homework_module.is_hw.is_dispatch == 1"
              >
                <CheckboxGroup
                  v-model="globalData.homework_module.is_hw.is_dispatch_hw"
                >
                  <Checkbox label="1">老师</Checkbox>
                  <Checkbox label="2">助教</Checkbox>
                </CheckboxGroup>
              </FormItem>
              <FormItem
                label="批改作业"
                prop="correct_homework"
                class="form-item-sub"
                v-if="globalData.homework_module.is_hw.is_dispatch == 1"
              >
                <CheckboxGroup
                  v-model="globalData.homework_module.is_hw.is_correct_hw"
                  @on-change="onCorrectHomeworkChange"
                >
                  <Checkbox label="1">老师</Checkbox>
                  <Checkbox label="2">助教</Checkbox>
                  <Checkbox
                    label="3"
                    v-if="
                      globalData.homework_module.is_hw.is_dispatch_hw.filter(
                        (i) => i == 1
                      ).length > 0
                    "
                    >其他老师</Checkbox
                  >
                  <Checkbox
                    label="4"
                    v-if="
                      globalData.homework_module.is_hw.is_dispatch_hw.filter(
                        (i) => i == 2
                      ).length > 0
                    "
                    >其他助教</Checkbox
                  >
                </CheckboxGroup>
              </FormItem>
            </FormItem>
            <div v-if="globalData.homework_module.is_hw.is_dispatch == 1">
              <div
                class="ivu-form-item ivu-form-item-required"
                style="margin-bottom: 0"
              >
                <label class="ivu-form-item-label" style="width: 150px"
                  >作业查看权限</label
                >
              </div>
              <FormItem
                label="讲师权限"
                prop="homework_module.is_oauth.teacher_oauth"
              >
                <RadioGroup
                  v-model="globalData.homework_module.is_oauth.teacher_oauth"
                >
                  <Radio
                    label="0"
                    :disabled="
                      globalData.homework_module.is_hw.is_correct_hw.filter(
                        (c) => c == 3
                      ).length > 0
                    "
                    >讲师不可以看课程其他讲师布置的作业</Radio
                  >
                  <Radio
                    label="1"
                    :disabled="
                      globalData.homework_module.is_hw.is_correct_hw.filter(
                        (c) => c == 3
                      ).length > 0
                    "
                    >讲师可以看课程其他讲师布置的作业</Radio
                  >
                </RadioGroup>
              </FormItem>
              <FormItem
                label="助教权限"
                prop="homework_module.is_oauth.assist_teacher_oauth"
              >
                <RadioGroup
                  v-model="
                    globalData.homework_module.is_oauth.assist_teacher_oauth
                  "
                >
                  <Radio
                    label="0"
                    :disabled="
                      globalData.homework_module.is_hw.is_correct_hw.filter(
                        (c) => c == 4
                      ).length > 0
                    "
                    >助教不可以看其他班级助教布置的作业</Radio
                  >
                  <Radio
                    label="1"
                    :disabled="
                      globalData.homework_module.is_hw.is_correct_hw.filter(
                        (c) => c == 4
                      ).length > 0
                    "
                    >助教可以看其他班级助教布置的作业</Radio
                  >
                </RadioGroup>
              </FormItem>
            </div>
          </div>
          <FormItem label="PC观看直播设置" prop="watch_live_type">
            <RadioGroup v-model="globalData.watch_live_type">
              <Radio :label="1">网页打开</Radio>
              <Radio :label="2">客户端打开</Radio>
              <Radio :label="3">自己选择</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="价格图标" prop="price_ico">
            <div style="display: flex; align-items: center">
              <div v-show="globalData.price_ico" class="avatar">
                <img :src="globalData.price_ico" alt />
                <Input
                  v-model="globalData.price_ico"
                  style="display: none"
                  clearable
                />
              </div>
              <Upload
                :action="baseUrl + '/api/public/img'"
                :show-upload-list="false"
                :headers="header"
                :on-success="successHanlderPrice"
                :format="['jpg', 'jpeg', 'png']"
              >
                <Button icon="ios-cloud-upload-outline">选择文件</Button>
                <p class="sm-title">
                  45*45像素或1:1，支持jpg、jpeg、png,小于100k
                </p>
              </Upload>
            </div>
          </FormItem>
          <FormItem label="实体商品价格图标" prop="entity_price_ico">
            <div style="display: flex; align-items: center">
              <div v-show="globalData.entity_price_ico" class="avatar">
                <img :src="globalData.entity_price_ico" alt />
                <Input
                  v-model="globalData.entity_price_ico"
                  style="display: none"
                  clearable
                />
              </div>
              <Upload
                :action="baseUrl + '/api/public/img'"
                :show-upload-list="false"
                :headers="header"
                :on-success="successHanlderEntityPrice"
                :format="['jpg', 'jpeg', 'png']"
              >
                <Button icon="ios-cloud-upload-outline">选择文件</Button>
                <p class="sm-title">
                  45*45像素或1:1，支持jpg、jpeg、png,小于100k
                </p>
              </Upload>
            </div>
          </FormItem>
          <!-- <FormItem prop="course_statement" label="课程声明">
            <Input
              placeholder="请输入"
              type="textarea"
              :rows="10"
              v-model="globalData.course_statement"
              clearable
            />
          </FormItem> -->
        </Form>
        <div style="text-align: right">
          <Button
            size="large"
            type="primary"
            style="margin: 0 15px"
            @click="submits('global')"
            >提交</Button
          >
          <Button size="large" @click="reset('globalData')">重置</Button>
        </div>
      </TabPane>
      <TabPane label="短信设置" name="sms">
        <div class="title">短信设置</div>
        <Form ref="sms" :rules="smsRule" :label-width="150" :model="smsData">
          <FormItem prop="access_key_id" label="access_key_id">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.access_key_id"
              clearable
            />
            <span>阿里access_key_id</span>
          </FormItem>
          <FormItem prop="access_key_secret" label="access_key_secret">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.access_key_secret"
              clearable
            />
            <span>阿里access_key_secret</span>
          </FormItem>
          <FormItem prop="sign_name" label="common_sign_name">
            <Input
              placeholder="请输入"
              v-model="smsData.sign_name"
              class="sms-input"
              clearable
            />
            <span>普通模板签名</span>
          </FormItem>
          <div class="title">短信模板</div>
          <FormItem prop="login" label="登录">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.login"
              clearable
            />
            <span>登录模板ID</span>
          </FormItem>
          <FormItem prop="getPassword" label="找回密码">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.getPassword"
              clearable
            />
            <span>找回密码模板ID</span>
          </FormItem>
          <FormItem prop="editMobile" label="更改手机号">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.editMobile"
              clearable
            />
            <span>更改手机号模板ID</span>
          </FormItem>
          <FormItem prop="loginOauth" label="三方登录">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.loginOauth"
              clearable
            />
            <span>三方登录模板ID</span>
          </FormItem>
          <FormItem prop="boundBank" label="绑定账户">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.boundBank"
              clearable
            />
            <span>绑定账户模板ID</span>
          </FormItem>
          <FormItem prop="downOrder" label="下单">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.downOrder"
              clearable
            />
            <span>下单模板ID</span>
          </FormItem>
          <FormItem prop="buyCourse" label="购买提醒">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.buyCourse"
              clearable
            />
            <span>购买提醒模板ID</span>
          </FormItem>
          <FormItem prop="cancelResOtoCourse" label="取消约课（学生）">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.cancelResOtoCourse"
              clearable
            />
            <span>取消约课（学生）模板ID</span>
          </FormItem>
          <FormItem prop="reservationSuccess" label="一对一预约成功学员">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.reservationSuccess"
              clearable
            />
            <span>一对一预约成功学员模板ID</span>
          </FormItem>
          <FormItem prop="reservationSuccessTeacher" label="一对一预约成功老师">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.reservationSuccessTeacher"
              clearable
            />
            <span>一对一预约成功老师模板ID</span>
          </FormItem>
          <FormItem prop="reservationOpen" label="一对一放课通知">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.reservationOpen"
              clearable
            />
            <span>一对一放课通知模板ID</span>
          </FormItem>
          <FormItem prop="cancelCourse" label="取消课程（管理员）">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.cancelCourse"
              clearable
            />
            <span>取消课程（管理员）模板ID</span>
          </FormItem>
          <FormItem prop="sendCommunicationTeacher" label="老师发起沟通记录">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.sendCommunicationTeacher"
              clearable
            />
            <span>老师发起沟通记录模板ID</span>
          </FormItem>
          <FormItem prop="startCourseTipHour" label="开课前6小时">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.startCourseTipHour"
              clearable
            />
            <span>开课前6小时模板ID</span>
          </FormItem>
          <FormItem prop="startCourseTipMinute" label="开课前15分钟提醒">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="smsData.startCourseTipMinute"
              clearable
            />
            <span>开课前15分钟提醒模板ID</span>
          </FormItem>
        </Form>
        <div style="text-align: right">
          <Button
            size="large"
            type="primary"
            style="margin: 0 15px"
            @click="submits('sms')"
            >提交</Button
          >
          <Button size="large" @click="reset('smsData')">重置</Button>
        </div>
      </TabPane>
      <TabPane label="三方登录" name="thirdLogin">
        <Form
          ref="thirdLogin"
          :rules="thirdLoginRule"
          :label-width="150"
          :model="thirdLoginData"
        >
          <div class="title">公众号三方登录</div>
          <FormItem prop="wxmp_appId" label="微信appId">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="thirdLoginData.wxmp_appId"
              clearable
            />
            <span>微信三方登录app ID</span>
          </FormItem>
          <FormItem prop="wxmp_appSecret" label="微信appSecret">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="thirdLoginData.wxmp_appSecret"
              clearable
            />
            <span>微信三方登录appSecret</span>
          </FormItem>

          <div class="title">小程序三方登录</div>
          <FormItem prop="wxxcx_appId" label="微信appId">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="thirdLoginData.wxxcx_appId"
              clearable
            />
            <span>微信三方登录app ID</span>
          </FormItem>
          <FormItem prop="wxxcx_appSecret" label="微信appSecret">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="thirdLoginData.wxxcx_appSecret"
              clearable
            />
            <span>微信三方登录appSecret</span>
          </FormItem>

          <div class="title">PC-微信设置</div>
          <FormItem prop="pc_wx_appId" label="微信appId">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="thirdLoginData.pc_wx_appId"
              clearable
            />
            <span>微信三方登录app ID</span>
          </FormItem>
          <FormItem prop="pc_wx_appSecret" label="微信appSecret">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="thirdLoginData.pc_wx_appSecret"
              clearable
            />
            <span>微信三方登录appSecret</span>
          </FormItem>
          <FormItem prop="pc_wx_callBack" label="微信callBack">
            <Input
              placeholder="请输入"
              v-model="thirdLoginData.pc_wx_callBack"
              class="sms-input"
              clearable
            />
            <span>微信三方登录授权回调地址</span>
          </FormItem>

          <div class="title">PC-QQ设置</div>
          <FormItem prop="pc_qq_appId" label="QQ_APPID">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="thirdLoginData.pc_qq_appId"
              clearable
            />
            <span>QQ三方登录app ID</span>
          </FormItem>
          <FormItem prop="pc_qq_appSecret" label="QQ_appSecret">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="thirdLoginData.pc_qq_appSecret"
              clearable
            />
            <span>QQ三方登录appSecret</span>
          </FormItem>
          <FormItem prop="pc_qq_callBack" label="QQ_callBack">
            <Input
              placeholder="请输入"
              v-model="thirdLoginData.pc_qq_callBack"
              class="sms-input"
              clearable
            />
            <span>QQ三方登录授权回调地址</span>
          </FormItem>

          <div class="title">APP-微信设置</div>
          <FormItem prop="app_wx_appId" label="微信appId">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="thirdLoginData.app_wx_appId"
              clearable
            />
            <span>微信三方登录app ID</span>
          </FormItem>
          <FormItem prop="app_wx_appSecret" label="微信appSecret">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="thirdLoginData.app_wx_appSecret"
              clearable
            />
            <span>微信三方登录appSecret</span>
          </FormItem>

          <div class="title">APP-QQ设置</div>
          <FormItem prop="app_qq_appId" label="QQ_APPID">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="thirdLoginData.app_qq_appId"
              clearable
            />
            <span>QQ三方登录app ID</span>
          </FormItem>
          <FormItem prop="app_qq_appSecret" label="QQ_appSecret">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="thirdLoginData.app_qq_appSecret"
              clearable
            />
            <span>QQ三方登录appSecret</span>
          </FormItem>
        </Form>
        <div style="text-align: right">
          <Button
            size="large"
            type="primary"
            style="margin: 0 15px"
            @click="submits('thirdLogin')"
            >提交</Button
          >
          <Button size="large" @click="reset('thirdLoginData')">重置</Button>
        </div>
      </TabPane>
      <TabPane label="支付设置" name="pay">
        <Table border :columns="payCol" :data="payData">
          <template slot-scope="{ row }" slot="name">
            <strong>{{ row.name }}</strong>
          </template>
          <template slot-scope="{ row }" slot="action">
            <Button type="text" size="small" @click="edit(row.name)"
              >编辑</Button
            >
          </template>
        </Table>
      </TabPane>
      <TabPane label="导航设置" name="nav">
        <NavSetting v-if="showNav"></NavSetting>
      </TabPane>
      <TabPane label="其他设置" name="other">
        <div class="title">百家云视频</div>
        <Form
          ref="other"
          :rules="otherRule"
          :label-width="150"
          :model="otherData"
        >
          <FormItem prop="partner_id" label="partner_id">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="otherData.partner_id"
              clearable
            />
            <span>百家云账号ID</span>
          </FormItem>
          <FormItem prop="partner_key" label="partner_key">
            <Input
              class="sms-input"
              placeholder="请输入"
              v-model="otherData.partner_key"
              clearable
            />
            <span>百家云账号密钥</span>
          </FormItem>
          <FormItem prop="secret_key" label="secret_key">
            <Input
              placeholder="请输入"
              v-model="otherData.secret_key"
              class="sms-input"
              clearable
            />
            <span>用于更新partner_key的密钥</span>
          </FormItem>
          <FormItem prop="api_url_pre" label="api_url_pre">
            <Input
              placeholder="请输入"
              v-model="otherData.api_url_pre"
              class="sms-input"
              clearable
            />
            <span>百家云接口地址</span>
          </FormItem>
        </Form>
        <div style="text-align: right">
          <Button
            size="large"
            type="primary"
            style="margin: 0 15px"
            @click="submits('other')"
            >提交</Button
          >
          <Button size="large" @click="reset('otherData')">重置</Button>
        </div>
      </TabPane>
      <TabPane label="网站设置" name="web">
        <Form ref="web" :rules="webRule" :label-width="150" :model="webData">
          <div class="title">网站设置</div>
          <FormItem prop="web_title" label="网站标题">
            <Input placeholder="请输入" v-model="webData.web_title" clearable />
          </FormItem>
          <FormItem label="网站logo" prop="web_logo">
            <div style="display: flex; align-items: center">
              <div v-show="webData.web_logo" class="avatar">
                <img :src="webData.web_logo" alt />
                <Input
                  v-model="webData.web_logo"
                  style="display: none"
                  clearable
                />
              </div>
              <Upload
                :action="baseUrl + '/api/public/img'"
                :show-upload-list="false"
                :headers="header"
                :on-success="successHanlderLog"
                :format="['jpg', 'jpeg', 'png']"
              >
                <Button icon="ios-cloud-upload-outline">选择文件</Button>
                <p class="sm-title">
                  435*255像素或1.7:1，支持jpg、jpeg、png,小于5M
                </p>
              </Upload>
            </div>
          </FormItem>
          <FormItem label="移动端logo" prop="mobile_logo">
            <div style="display: flex; align-items: center">
              <div v-show="webData.mobile_logo" class="avatar">
                <img :src="webData.mobile_logo" alt />
                <Input
                  v-model="webData.mobile_logo"
                  style="display: none"
                  clearable
                />
              </div>
              <Upload
                :action="baseUrl + '/api/public/img'"
                :show-upload-list="false"
                :headers="header"
                :on-success="successHanlderMobileLog"
                :format="['jpg', 'jpeg', 'png']"
              >
                <Button icon="ios-cloud-upload-outline">选择文件</Button>
                <p class="sm-title">
                  435*255像素或1.7:1，支持jpg、jpeg、png,小于5M
                </p>
              </Upload>
            </div>
          </FormItem>
          <FormItem label="网站ico" prop="web_ico">
            <div style="display: flex; align-items: center">
              <div v-show="webData.web_ico" class="avatar">
                <img :src="webData.web_ico" alt />
                <Input
                  v-model="webData.web_ico"
                  style="display: none"
                  clearable
                />
              </div>
              <Upload
                :action="baseUrl + '/api/public/img'"
                :show-upload-list="false"
                :headers="header"
                :on-success="successHanlderIco"
                :format="['ico']"
              >
                <Button icon="ios-cloud-upload-outline">选择文件</Button>
                <p class="sm-title">64*64像素或1:1，支持ico,小于300k</p>
              </Upload>
            </div>
          </FormItem>
          <FormItem label="管理端logo" prop="manager_logo">
            <div style="display: flex; align-items: center">
              <div v-show="webData.manager_logo" class="avatar">
                <img :src="webData.manager_logo" alt />
                <Input
                  v-model="webData.manager_logo"
                  style="display: none"
                  clearable
                />
              </div>
              <Upload
                :action="baseUrl + '/api/public/img'"
                :show-upload-list="false"
                :headers="header"
                :on-success="successHanlderManagerLog"
                :format="['jpg', 'jpeg', 'png']"
              >
                <Button icon="ios-cloud-upload-outline">选择文件</Button>
                <p class="sm-title">
                  435*255像素或1.7:1，支持jpg、jpeg、png,小于5M
                </p>
              </Upload>
            </div>
          </FormItem>
          <FormItem prop="web_description" label="网站描述">
            <Input
              placeholder="请输入"
              v-model="webData.web_description"
              clearable
            />
          </FormItem>
          <FormItem prop="web_keywords" label="网站关键字">
            <Input
              placeholder="请输入"
              v-model="webData.web_keywords"
              clearable
            />
          </FormItem>
          <FormItem prop="copyright" label="网站版权">
            <Input placeholder="请输入" v-model="webData.copyright" clearable />
          </FormItem>
          <FormItem prop="record_no" label="网站备案号">
            <Input
              placeholder="请输入网站备案号"
              v-model="webData.record_no"
              clearable
            />
          </FormItem>
          <FormItem prop="record_no_link" label="网站备案号链接">
            <Input
              placeholder="请输入网站备案号链接"
              v-model="webData.record_no_link"
              clearable
            />
          </FormItem>
          <FormItem prop="pc_address" label="PC端访问地址">
            <Input
              placeholder="请输入"
              v-model="webData.pc_address"
              clearable
            />
          </FormItem>
          <FormItem prop="H5_address" label="H5端访问地址">
            <Input
              placeholder="请输入"
              v-model="webData.H5_address"
              clearable
            />
          </FormItem>
          <FormItem prop="contact" label="联系方式">
            <Input placeholder="请输入" v-model="webData.contact" clearable />
          </FormItem>
          <div class="title">客户端下载设置</div>
          <FormItem label="客户端宣传图" prop="download_banner">
            <div style="display: flex; align-items: center">
              <div v-show="webData.download_banner" class="avatar">
                <img :src="webData.download_banner" alt />
                <Input
                  v-model="webData.download_banner"
                  style="display: none"
                  clearable
                />
              </div>
              <Upload
                :action="baseUrl + '/api/public/img'"
                :show-upload-list="false"
                :headers="header"
                :on-success="successHanlderBanner"
                :format="['jpg', 'jpeg', 'png']"
              >
                <Button icon="ios-cloud-upload-outline">选择文件</Button>
                <p class="sm-title">
                  435*255像素或1.7:1，支持jpg、jpeg、png,小于5M
                </p>
              </Upload>
            </div>
          </FormItem>
          <FormItem prop="download_title" label="客户端宣传标题">
            <Input
              placeholder="请输入"
              v-model="webData.download_title"
              clearable
            />
          </FormItem>
          <FormItem prop="download_description" label="客户端宣传说明">
            <Input
              placeholder="请输入"
              v-model="webData.download_description"
              clearable
            />
          </FormItem>
          <FormItem label="iOS下载二维码" prop="download_ios_code">
            <div style="display: flex; align-items: center">
              <div v-show="webData.download_ios_code" class="avatar">
                <img :src="webData.download_ios_code" alt />
                <Input
                  v-model="webData.download_ios_code"
                  style="display: none"
                  clearable
                />
              </div>
              <Upload
                :action="baseUrl + '/api/public/img'"
                :show-upload-list="false"
                :headers="header"
                :on-success="successHanlderIos"
                :format="['jpg', 'jpeg', 'png']"
              >
                <Button icon="ios-cloud-upload-outline">选择文件</Button>
                <p class="sm-title">
                  435*255像素或1.7:1，支持jpg、jpeg、png,小于5M
                </p>
              </Upload>
            </div>
          </FormItem>
          <FormItem label="Android下载二维码" prop="download_android_code">
            <div style="display: flex; align-items: center">
              <div v-show="webData.download_android_code" class="avatar">
                <img :src="webData.download_android_code" alt />
                <Input
                  v-model="webData.download_android_code"
                  style="display: none"
                  clearable
                />
              </div>
              <Upload
                :action="baseUrl + '/api/public/img'"
                :show-upload-list="false"
                :headers="header"
                :on-success="successHanlderAnd"
                :format="['jpg', 'jpeg', 'png']"
              >
                <Button icon="ios-cloud-upload-outline">选择文件</Button>
                <p class="sm-title">
                  435*255像素或1.7:1，支持jpg、jpeg、png,小于5M
                </p>
              </Upload>
            </div>
          </FormItem>
        </Form>
        <div style="text-align: right">
          <Button
            size="large"
            type="primary"
            style="margin: 0 15px"
            @click="submits('web')"
            >提交</Button
          >
          <Button size="large" @click="reset('webData')">重置</Button>
        </div>
      </TabPane>
      <TabPane label="协议设置" name="protocol">
        <Form
          ref="protocol"
          :model="protocolData"
          :rules="protocolRule"
          :label-width="100"
        >
          <FormItem label="iOS充值协议" prop="charge_contract">
            <UEditor v-model="protocolData.charge_contract"></UEditor>
          </FormItem>
          <FormItem label="用户注册协议" prop="user_register_contract">
            <UEditor v-model="protocolData.user_register_contract"></UEditor>
          </FormItem>
          <FormItem label="隐私保护政策" prop="user_protect_contract">
            <UEditor v-model="protocolData.user_protect_contract"></UEditor>
          </FormItem>
          <FormItem label="客服协议" prop="customer_chat_contract">
            <Input
              v-model="protocolData.customer_chat_contract"
              type="textarea"
              :rows="10"
            />
          </FormItem>
          <FormItem label="订单隐私协议" prop="order_contract">
            <UEditor v-model="protocolData.order_contract" />
          </FormItem>
          <FormItem label="优惠券使用协议" prop="coupon_use_contract">
            <UEditor v-model="protocolData.coupon_use_contract"></UEditor>
          </FormItem>
          <FormItem label="会员协议" prop="vip_user_contract">
            <UEditor v-model="protocolData.vip_user_contract"></UEditor>
          </FormItem>
          <FormItem label="温馨提示" prop="reminder_contract">
            <UEditor v-model="protocolData.reminder_contract"></UEditor>
          </FormItem>
          <div style="text-align: right">
            <Button size="large" type="primary" @click="submits('protocol')"
              >提交</Button
            >
          </div>
        </Form>
      </TabPane>
    </Tabs>
    <Modal
      :mask-closable="false"
      class="vertical-center-modal"
      v-model="moveModal"
      :title="title"
      width="450"
    >
      <Form ref="pay" :model="pays" style="margin: 0 auto" :label-width="100">
        <FormItem prop="app_id" label="APPID">
          <Input v-model="pays.app_id" />
        </FormItem>
        <FormItem prop="notify_url" label="notify_url">
          <Input v-model="pays.notify_url" />
        </FormItem>
        <div v-show="title == '支付宝支付'">
          <FormItem prop="return_url" label="return_url">
            <Input v-model="pays.return_url" />
          </FormItem>
          <FormItem prop="ali_public_key" label="ali_public_key">
            <Input v-model="pays.ali_public_key" />
          </FormItem>
          <FormItem prop="private_key" label="private_key">
            <Input v-model="pays.private_key" />
          </FormItem>
        </div>
        <div v-show="title != '支付宝支付'">
          <FormItem label="miniapp_id">
            <Input v-model="pays.miniapp_id" />
          </FormItem>
          <FormItem label="mch_id">
            <Input v-model="pays.mch_id" />
          </FormItem>
          <FormItem label="key">
            <Input v-model="pays.key" />
          </FormItem>
        </div>
      </Form>
      <div slot="footer">
        <Button @click="moveModal = false">取消</Button>
        <Button type="primary" @click="confirm()">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import NavSetting from "./NavSetting";
import UEditor from "@/components/UEditor.vue";

const buildConfig = require("../../../build/" + process.env.BUILD_ENV + ".js");
export default {
  name: "WebSite",
  components: {
    NavSetting,
    UEditor,
  },
  data() {
    return {
      showNav: false,
      // 全局
      globalRule: {
        default_pass: [{ required: true, message: "请输入" }],
        teacher_default_pass: [{ required: true, message: "请输入" }],
        price_ico: [{ required: true, message: "请输入" }],
        entity_price_ico: [{ required: true, message: "请输入" }],
        app_video_cache: [{ required: true, message: "请输入" }],
        // course_statement: [{ required: true, message: "请输入" }],
        switch_vip_module: [{ required: true, message: "请输入" }],
        switch_study_module: [{ required: true, message: "请输入" }],
        switch_question_module: [{ required: true, message: "请输入" }],
        class_module: [{ required: true, message: "请输入" }],
        watch_live_type: [{ required: true, message: "请输入" }],
        "homework_module.is_open": [{ required: true, message: "请选择" }],
        "homework_module.is_hw.is_dispatch": [
          { required: true, message: "请选择" },
        ],
      },
      globalData: {
        default_pass: "",
        teacher_default_pass: "",
        price_ico: "",
        entity_price_ico: "",
        course_statement: "暂无",
        app_video_cache: "",
        switch_vip_module: 0,
        switch_study_module: "",
        switch_question_module: "",
        watch_live_type: "",
        class_module: "",
        homework_module: {
          is_open: "1",
          is_hw: {},
        },
      },
      //   短信
      smsRule: {
        access_key_id: [{ required: true, message: "请输入" }],
        access_key_secret: [{ required: true, message: "请输入" }],
        sign_name: [{ required: true, message: "请输入" }],
        login: [{ required: true, message: "请输入" }],
        getPassword: [{ required: true, message: "请输入" }],
        editMobile: [{ required: true, message: "请输入" }],
        loginOauth: [{ required: true, message: "请输入" }],
        boundBank: [{ required: true, message: "请输入" }],
        downOrder: [{ required: true, message: "请输入" }],
        buyCourse: [{ required: true, message: "请输入" }],
        cancelResOtoCourse: [{ required: true, message: "请输入" }],
        reservationSuccess: [{ required: true, message: "请输入" }],
        reservationSuccessTeacher: [{ required: true, message: "请输入" }],
        reservationOpen: [{ required: true, message: "请输入" }],
        cancelCourse: [{ required: true, message: "请输入" }],
        sendCommunicationTeacher: [{ required: true, message: "请输入" }],
        startCourseTipHour: [{ required: true, message: "请输入" }],
        startCourseTipMinute: [{ required: true, message: "请输入" }],
      },
      smsData: {
        access_key_id: "",
        access_key_secret: "",
        sign_name: "",
        login: "",
        getPassword: "",
        editMobile: "",
        loginOauth: "",
        boundBank: "",
        downOrder: "",
        buyCourse: "",
        cancelResOtoCourse: "",
        reservationSuccess: "",
        reservationSuccessTeacher: "",
        reservationOpen: "",
        cancelCourse: "",
        sendCommunicationTeacher: "",
        startCourseTipHour: "",
        startCourseTipMinute: "",
      },
      //   三方
      thirdLoginRule: {
        wxmp_appId: [{ required: true, message: "请输入" }],
        wxmp_appSecret: [{ required: true, message: "请输入" }],
        wxxcx_appId: [{ required: true, message: "请输入" }],
        wxxcx_appSecret: [{ required: true, message: "请输入" }],
        pc_qq_appId: [{ required: true, message: "请输入" }],
        pc_qq_appSecret: [{ required: true, message: "请输入" }],
        pc_qq_callBack: [{ required: true, message: "请输入" }],
        pc_wx_appId: [{ required: true, message: "请输入" }],
        pc_wx_appSecret: [{ required: true, message: "请输入" }],
        pc_wx_callBack: [{ required: true, message: "请输入" }],
        app_qq_appId: [{ required: true, message: "请输入" }],
        app_qq_appSecret: [{ required: true, message: "请输入" }],
        app_wx_appId: [{ required: true, message: "请输入" }],
        app_wx_appSecret: [{ required: true, message: "请输入" }],
      },
      thirdLoginData: {
        wxmp_appId: "",
        wxmp_appSecret: "",
        wxxcx_appId: "",
        wxxcx_appSecret: "",
        pc_qq_appId: "",
        pc_qq_appSecret: "",
        pc_qq_callBack: "",
        pc_wx_appId: "",
        pc_wx_appSecret: "",
        pc_wx_callBack: "",
        app_qq_appId: "",
        app_qq_appSecret: "",
        app_wx_appId: "",
        app_wx_appSecret: "",
      },
      //   支付
      payCol: [
        {
          title: "配置类型",
          key: "name",
          minWidth: 130,
          align: "center",
        },
        {
          title: "app_id",
          key: "app_id",
          minWidth: 200,
          align: "center",
        },
        {
          title: "回调地址",
          key: "notify_url",
          minWidth: 200,
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          minWidth: 100,
          fixed: "right",
          align: "center",
        },
      ],
      payData: [],
      moveModal: false,
      title: "",
      pays: {
        app_id: "",
        notify_url: "",
        return_url: "",
        ali_public_key: "",
        private_key: "",
        miniapp_id: "",
        mch_id: "",
        key: "",
      },
      //   其他
      otherData: {
        partner_id: "",
        partner_key: "",
        secret_key: "",
        api_url_pre: "",
        // appKey: "",
        // masterSecret: ""
      },
      otherRule: {
        partner_id: [{ required: true, message: "请输入" }],
        partner_key: [{ required: true, message: "请输入" }],
        secret_key: [{ required: true, message: "请输入" }],
        api_url_pre: [{ required: true, message: "请输入" }],
        appKey: [{ required: true, message: "请输入" }],
        masterSecret: [{ required: true, message: "请输入" }],
      },
      //   网站设置
      webRule: {
        web_title: [{ required: true, message: "请输入" }],
        web_logo: [{ required: true, message: "请输入" }],
        mobile_logo: [{ required: true, message: "请输入" }],
        web_ico: [{ required: true, message: "请输入" }],
        manager_logo: [{ required: true, message: "请输入" }],
        web_description: [{ required: true, message: "请输入" }],
        web_keywords: [{ required: true, message: "请输入" }],
        copyright: [{ required: true, message: "请输入" }],
        pc_address: [{ required: true, message: "请输入" }],
        H5_address: [{ required: true, message: "请输入" }],
        contact: [{ required: true, message: "请输入" }],
        download_title: [{ required: true, message: "请输入" }],
        download_description: [{ required: true, message: "请输入" }],
      },
      webData: {
        web_title: "",
        web_logo: "",
        mobile_logo: "",
        web_ico: "",
        manager_logo: "",
        download_banner: "",
        download_ios_code: "",
        download_android_code: "",
        download_xcx_code: "",
        web_description: "",
        web_keywords: "",
        copyright: "",
        pc_address: "",
        H5_address: "",
        contact: "",
      },
      protocolData: {
        charge_contract: "",
        user_register_contract: "",
        user_protect_contract: "",
        customer_chat_contract: "",
        coupon_use_contract: "",
        vip_user_contract: "",
        reminder_contract: "",
        order_contract: "",
      },
      protocolRule: {
        charge_contract: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        user_register_contract: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        user_protect_contract: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
      },
      baseUrl: buildConfig.BASE_URL,
      header: {
        Authorization: "Bearer " + localStorage.adminToken,
      },
    };
  },
  created() {
    this.actionGlobal(1);
    // this.actionSms(1);
    // this.actionThirdLogin(1);
    // this.actionPay(1);
    // this.actionOther(1);
    // this.actionWeb(1);
  },
  methods: {
    onCorrectHomeworkChange() {
      if (
        this.globalData.homework_module.is_hw.is_correct_hw.filter(
          (c) => c == 3
        ).length > 0
      ) {
        this.globalData.homework_module.is_oauth.teacher_oauth = "1";
      }
      if (
        this.globalData.homework_module.is_hw.is_correct_hw.filter(
          (c) => c == 4
        ).length > 0
      ) {
        this.globalData.homework_module.is_oauth.assist_teacher_oauth = "1";
      }
    },
    submits(name) {
      this.$refs[name].validate((val) => {
        if (val) {
          if (name == "global") {
            this.actionGlobal();
          } else if (name == "sms") {
            this.actionSms();
          } else if (name == "thirdLogin") {
            this.actionThirdLogin();
          } else if (name == "other") {
            this.actionOther();
          } else if (name == "web") {
            this.actionWeb();
          } else if (name == "protocol") {
            this.actionProtocol();
          }
        } else {
          this.$Message.error("输入有误，请检查！");
        }
      });
    },
    reset(name) {
      for (let i in this[name]) {
        this[name][i] = "";
      }
    },
    //tab点击切换
    showName(name) {
      this.showNav = false;
      switch (name) {
        case "global":
          this.actionGlobal(1);
          break;
        case "sms":
          this.actionSms(1);
          break;
        case "thirdLogin":
          this.actionThirdLogin(1);
          break;
        case "pay":
          this.actionPay(1);
          break;
        case "other":
          this.actionOther(1);
          break;
        case "web":
          this.actionWeb(1);
          break;
        case "nav":
          this.showNav = true;
          break;
        case "protocol":
          this.actionProtocol(1);
          break;
      }
    },
    // 设置全局
    actionGlobal(action) {
      if (action == 1) {
        this.$http.get(`/api/commonSetting`).then((res) => {
          let globalData = res;
          if (globalData.homework_module.is_open == "1") {
            if (
              globalData.homework_module &&
              globalData.homework_module.is_hw
            ) {
              if (globalData.homework_module.is_hw.is_dispatch_hw) {
                globalData.homework_module.is_hw.is_dispatch_hw =
                  globalData.homework_module.is_hw.is_dispatch_hw.split(",");
              } else {
                globalData.homework_module.is_hw.is_dispatch_hw = [];
              }
              if (globalData.homework_module.is_hw.is_correct_hw) {
                globalData.homework_module.is_hw.is_correct_hw =
                  globalData.homework_module.is_hw.is_correct_hw.split(",");
              } else {
                globalData.homework_module.is_hw.is_correct_hw = [];
              }
            }
          }
          this.globalData = globalData;
        });
      } else {
        let globalData = JSON.parse(JSON.stringify(this.globalData));
        let homework_module = globalData.homework_module;
        if (homework_module.is_open == 1) {
          homework_module.is_hw.is_dispatch_hw =
            homework_module.is_hw.is_dispatch_hw.join(",");
          homework_module.is_hw.is_correct_hw =
            homework_module.is_hw.is_correct_hw.join(",");
        }
        globalData.homework_module = JSON.stringify(globalData.homework_module);
        this.$http.post(`/api/commonSetting`, globalData).then(() => {
          this.$Message.success("成功");
          this.actionGlobal(1);
        });
      }
    },
    // 短信设置
    actionSms(action) {
      if (action == 1) {
        this.$http.get(`/api/smsSetting`).then((res) => {
          this.smsData = res;
        });
      } else {
        this.$http.post(`/api/smsSetting`, this.smsData).then(() => {
          this.$Message.success("成功");
          this.actionSms(1);
        });
      }
    },
    // 三方设置
    actionThirdLogin(action) {
      if (action == 1) {
        this.$http.get(`/api/thirdLoginSetting`).then((res) => {
          this.thirdLoginData.wxmp_appId = res.wx_mp_config.appId;
          this.thirdLoginData.wxmp_appSecret = res.wx_mp_config.appSecret;
          this.thirdLoginData.wxxcx_appId = res.wx_xcx_config.appId;
          this.thirdLoginData.wxxcx_appSecret = res.wx_xcx_config.appSecret;
          this.thirdLoginData.pc_wx_appId = res.pc_wx_login_config.appId;
          this.thirdLoginData.pc_wx_appSecret =
            res.pc_wx_login_config.appSecret;
          this.thirdLoginData.pc_wx_callBack = res.pc_wx_login_config.callBack;
          this.thirdLoginData.pc_qq_appId = res.pc_qq_login_config.appId;
          this.thirdLoginData.pc_qq_appSecret =
            res.pc_qq_login_config.appSecret;
          this.thirdLoginData.pc_qq_callBack = res.pc_qq_login_config.callBack;
          this.thirdLoginData.app_qq_appId = res.app_qq_login_config.appId;
          this.thirdLoginData.app_qq_appSecret =
            res.app_qq_login_config.appSecret;
          this.thirdLoginData.app_wx_appId = res.app_wx_login_config.appId;
          this.thirdLoginData.app_wx_appSecret =
            res.app_wx_login_config.appSecret;
        });
      } else {
        let params = {
          wx_mp_config: {
            appId: this.thirdLoginData.wxmp_appId,
            appSecret: this.thirdLoginData.wxmp_appSecret,
          },
          wx_xcx_config: {
            appId: this.thirdLoginData.wxxcx_appId,
            appSecret: this.thirdLoginData.wxxcx_appSecret,
          },
          pc_wx_login_config: {
            appId: this.thirdLoginData.pc_wx_appId,
            appSecret: this.thirdLoginData.pc_wx_appSecret,
            callBack: this.thirdLoginData.pc_wx_callBack,
          },
          pc_qq_login_config: {
            appId: this.thirdLoginData.pc_qq_appId,
            appSecret: this.thirdLoginData.pc_qq_appSecret,
            callBack: this.thirdLoginData.pc_qq_callBack,
          },
          app_wx_login_config: {
            appId: this.thirdLoginData.app_wx_appId,
            appSecret: this.thirdLoginData.app_wx_appSecret,
          },
          app_qq_login_config: {
            appId: this.thirdLoginData.app_qq_appId,
            appSecret: this.thirdLoginData.app_qq_appSecret,
          },
        };
        this.$http.post(`/api/thirdLoginSetting`, params).then(() => {
          this.$Message.success("成功");
          this.actionThirdLogin(1);
        });
      }
    },
    // 支付
    actionPay(action, name, params) {
      if (action == 1) {
        this.payData = [];
        this.$http.get(`/api/alipaySetting`).then((res) => {
          res.name = "支付宝";
          this.alipaySetting = res;
          this.payData.push(res);
        });
        this.$http.get(`/api/wxpayPcSetting`).then((res) => {
          res.name = "微信支付";
          this.wxpayPcSetting = res;
          this.payData.push(res);
        });
        this.$http.get(`/api/wxpayAPPSetting`).then((res) => {
          res.name = "微信APP支付";
          this.wxpayAPPSetting = res;
          this.payData.push(res);
        });
      } else {
        this.$http.post(`/api/${name}`, params).then(() => {
          this.$Message.success("成功");
          this.moveModal = false;
          this.actionPay(1);
        });
      }
    },
    // 支付编辑
    edit(name) {
      let currentData;
      if (name == "支付宝") {
        this.title = "支付宝支付";
        currentData = this.alipaySetting;
      } else if (name == "微信支付") {
        this.title = "微信支付";
        currentData = this.wxpayPcSetting;
      } else {
        this.title = "微信APP支付";
        currentData = this.wxpayAPPSetting;
      }
      for (let i in this.pays) {
        if (currentData[i]) {
          this.pays[i] = currentData[i];
        }
      }
      this.moveModal = true;
    },
    // 支付提交
    confirm() {
      let name = "";
      let params;
      if (this.title == "支付宝支付") {
        name = "alipaySetting";
        params = {
          app_id: this.pays.app_id,
          notify_url: this.pays.notify_url,
          return_url: this.pays.return_url,
          ali_public_key: this.pays.ali_public_key,
          private_key: this.pays.private_key,
        };
      } else if (this.title == "微信支付") {
        name = "wxpayPcSetting";
        params = {
          app_id: this.pays.app_id,
          miniapp_id: this.pays.miniapp_id,
          mch_id: this.pays.mch_id,
          key: this.pays.key,
          notify_url: this.pays.notify_url,
        };
      } else {
        name = "wxpayAPPSetting";
        params = {
          app_id: this.pays.app_id,
          miniapp_id: this.pays.miniapp_id,
          mch_id: this.pays.mch_id,
          key: this.pays.key,
          notify_url: this.pays.notify_url,
        };
      }
      for (let i in params) {
        if (params[i] == "") {
          this.$Message.error("有未填项！");
          return;
        }
      }
      this.actionPay(2, name, params);
    },
    // 其他设置
    actionOther(action) {
      if (action == 1) {
        this.$http.get(`/api/otherSetting`).then((res) => {
          for (let i in res) {
            if (i == "appKey" || i == "appKey") {
              continue;
            } else {
              this.otherData[i] = res[i];
            }
          }
        });
      } else {
        this.$http.post(`/api/otherSetting`, this.otherData).then(() => {
          this.$Message.success("成功");
          this.actionOther(1);
        });
      }
    },
    // 网站设置
    successHanlderLog(response) {
      this.webData.web_logo = response.data.path;
    },
    successHanlderMobileLog(response) {
      this.webData.mobile_logo = response.data.path;
    },
    successHanlderIco(response) {
      this.webData.web_ico = response.data.path;
    },
    successHanlderManagerLog(response) {
      this.webData.manager_logo = response.data.path;
    },
    successHanlderBanner(response) {
      this.webData.download_banner = response.data.path;
    },
    successHanlderIos(response) {
      this.webData.download_ios_code = response.data.path;
    },
    successHanlderAnd(response) {
      this.webData.download_android_code = response.data.path;
    },
    successHanlderXcx(response) {
      this.webData.download_xcx_code = response.data.path;
    },
    successHanlderPrice(response) {
      this.globalData.price_ico = response.data.path;
    },
    successHanlderEntityPrice(response) {
      this.globalData.entity_price_ico = response.data.path;
    },
    actionWeb(action) {
      if (action == 1) {
        this.$http.get(`/api/webSetting`).then((res) => {
          this.webData = res;
        });
      } else {
        this.$http.post(`/api/webSetting`, this.webData).then(() => {
          this.$Message.success("成功");
          this.actionWeb(1);
        });
      }
    },
    actionProtocol(action) {
      if (action == 1) {
        this.$http
          .get("/api/contract/get", {
            params:
              "order_contract,charge_contract,user_register_contract,user_protect_contract,customer_chat_contract,coupon_use_contract,vip_user_contract,reminder_contract",
          })
          .then((data) => {
            const contract = this.protocolData;
            Object.keys(contract).forEach((key) => {
              contract[key] = data[key] || "";
            });
          });
      } else {
        this.$http
          .post("/api/contract/upload", {
            params: JSON.stringify(this.protocolData),
          })
          .then(() => {
            this.$Message.success("提交成功");
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ivu-tabs .ivu-tabs-tabpane {
  padding: 20px;
}

.title {
  position: relative;
  margin-bottom: 20px;
  padding: 5px 15px;
}

.title::before {
  display: block;
  position: absolute;
  left: 0;
  top: 7px;
  content: "";
  height: 20px;
  background-color: #2d8cf0;
  width: 4px;
}

.sms-input {
  width: 300px;
  margin-right: 10px;
}

.avatar {
  max-width: 100px;
  margin-right: 20px;
}

.avatar img {
  max-width: 100px;
}

.form-item-sub {
  &:nth-child(2) {
    margin-bottom: 24px;
  }
  /deep/ .ivu-form-item-label {
    width: auto !important;
  }
}
</style>
